import { useClassified } from "@/contexts/classified";
// eslint-disable-next-line no-restricted-imports
import { useThorEvent } from "@aviv-dxp/react-thor";
export const useTrackingLegacyLeadEvents = () => {
    var _a, _b;
    const products = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.legacyTracking) === null || _b === void 0 ? void 0 : _b.products;
    const useTrackingLeadConversionMail = () => {
        const eventData = {
            type: "mail",
            description: "conversion",
            infos: "",
            email_lead: "",
            products,
            event: "interaction",
        };
        return useThorEvent({
            compatibilities: { GA3: true, GA4: false },
            eventData,
        });
    };
    const useTrackingLeadConfirmationMail = () => {
        const eventData = {
            type: "mail",
            description: "confirmation",
            infos: "",
            email_lead: "",
            products,
            event: "interaction",
        };
        return useThorEvent({
            compatibilities: { GA3: true, GA4: false },
            eventData,
        });
    };
    const useTrackingLeadConversionPhone = () => {
        const eventData = {
            type: "phone",
            description: "conversion",
            infos: "",
            products,
            event: "interaction",
        };
        return useThorEvent({
            compatibilities: { GA3: true, GA4: false },
            eventData,
        });
    };
    const legacyLeadConversionMail = useTrackingLeadConversionMail();
    const legacyLeadConfirmationMail = useTrackingLeadConfirmationMail();
    const legacyLeadConversionPhone = useTrackingLeadConversionPhone();
    return {
        legacyLeadConversionMail,
        legacyLeadConfirmationMail,
        legacyLeadConversionPhone,
    };
};
